var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSocialApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-social-apple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 28,
    height: 28,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(3.5 0.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M79.578,136.86c-2.205,0-3.138,1.052-4.674,1.052-1.575,0-2.776-1.044-4.687-1.044a6.4,6.4,0,0,0-5.132,3.087c-1.779,2.743-1.477,7.909,1.4,12.31,1.031,1.575,2.407,3.342,4.212,3.361h.033c1.569,0,2.035-1.027,4.194-1.039h.033c2.127,0,2.553,1.033,4.116,1.033h.033c1.805-.019,3.255-1.977,4.286-3.546a17.063,17.063,0,0,0,1.586-2.972,5.392,5.392,0,0,1-.715-9.752,6.221,6.221,0,0,0-4.693-2.487Z",
    transform: "translate(-63.981 -131.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M253.492,32a5.78,5.78,0,0,0-3.741,2.016,4.978,4.978,0,0,0-1.221,3.878h.105a4.919,4.919,0,0,0,3.665-1.92A5.333,5.333,0,0,0,253.492,32Z",
    transform: "translate(-238.38 -32)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialApple);
export default __webpack_public_path__ + "static/media/icon-social-apple.c354f55e453f6fdad1a3ca4cbdeda892.svg";
export { ForwardRef as ReactComponent };